import React from "react";
import {
  SmileTwoTone,
  HeartTwoTone,
  CheckCircleTwoTone,
} from "@ant-design/icons";
import { Form, Row, Col, Button } from "antd";
import UnifiedInput from "../../components/ReportFormGenerator/UnifiedInput/UnifiedInput";
import HModal from "../HModal";
import liracrypt from "../../components/Liracrypt/liracrypt";

function RetroCards({
  completed,
  disabled,
  inspectorName,
  inspectorId,
  remark,
  ok,
  rej,
  tot,
  _id,
  setState,
}) {
  const [modalVisible, setModalVisible] = React.useState(false);
  const [data, setData] = React.useState(null);
  const [modalLoading, setModalLoading] = React.useState(false);
  const [form] = Form.useForm();

  const EditClick = () => {
    setModalLoading(true);
    setModalVisible(true);
    liracrypt
      .get("/smodal", {
        dictName: "FourM_BSL_RetroCheckRecords",
        auxFunc: {
          auxFuncName: "update_default_values",
          auxFuncParams: { auxSubFuncName: "BslFourM_Retro", fourMid: _id }
        }
      })
      .then((res, req) => {

        setData(res["data"]["config"]);
        setModalLoading(false);
        // setData(res.data.data);
      })
      .catch((err) => { });
  };

  const onFinish = (value) => {

  };
  return (
    <>
      <HModal
        isModalVisible={modalVisible}
        modalLoading={modalLoading}
        setIsModalVisible={setModalVisible}
        modalMethod={"edit"}
        action={{ edit: data }}
        modalData={null}
        extraData={{ _id: _id, typ: "retroChk" }}
        mergeData={true}
        setState={setState}
      />
      <div
        style={{
          margin: "10px",
          padding: "20px",
          backgroundColor: "#3b3b3b",
          minHeight: "200px",
          borderRadius: "10px",
          boxShadow: "5px 5px 10px #1e1e1e,-5px -5px 10px #2e2e2e",
          border: completed ? "2px solid #52c41a" : "",
        }}
      >
        <div style={{ display: "flex", alignItems: "center" }}>
          <div
            style={{
              fontSize: "20px",
              fontWeight: 600,
              display: "flex",
              flex: 1,
              color: "lightgrey",
            }}
          >
            {"RETRO CHECK RECORDS"}
          </div>
          <div style={{ display: "flex", flex: 1, justifyContent: "flex-end" }}>
            {completed ? (
              <CheckCircleTwoTone
                twoToneColor={completed ? "#52c41a" : "lightgrey"}
                style={{ fontSize: "30px" }}
              />
            ) : (
              <></>
            )}
          </div>
        </div>
        <div className="AuditSection CreateAudit">
          <div className="ThemeForm">
            <Form
              name="ReportForm"
              form={form}
              labelCol={{ span: 8 }}
              wrapperCol={{ span: 16 }}
              layout="horizontal"
              colon={false}
              onFinish={onFinish}
              size="large"
            >
              <Row gutter={24} justify="center" style={{ marginTop: "20px" }}>
                <Col span={12}>
                  <UnifiedInput
                    form={form}
                    colSpan={24}
                    disabled={disabled ? disabled : false}
                    typ={"textBox"}
                    name={"ok"}
                    // placeHolder={"Remarks"}
                    label="OK Qty"
                    errorMessage={"Please Select OK Qty !"}
                    required={false}
                    defaultValue={ok ? ok.toString() : "0"}
                  />
                  <UnifiedInput
                    form={form}
                    colSpan={24}
                    disabled={disabled ? disabled : false}
                    typ={"textBox"}
                    name={"rej"}
                    // placeHolder={"Remarks"}
                    label="REJ Qty"
                    errorMessage={"Please Select REJ Qty !"}
                    required={false}
                    defaultValue={rej ? rej.toString() : "0"}
                  />
                  <UnifiedInput
                    form={form}
                    colSpan={24}
                    disabled={disabled ? disabled : false}
                    typ={"textBox"}
                    name={"total"}
                    // placeHolder={"Remarks"}
                    label="TOTAL Qty (Check 5 Nos)"
                    errorMessage={"Please Select TOTAL Qty !"}
                    required={false}
                    defaultValue={tot ? tot.toString() : "0"}
                  />
                  <UnifiedInput
                    form={form}
                    colSpan={24}
                    disabled={disabled ? disabled : false}
                    typ={"textBox"}
                    name={"inspector"}
                    // placeHolder={"Remarks"}
                    label="Inspector"
                    errorMessage={"Please Select Inspector !"}
                    required={false}
                    defaultValue={inspectorName}
                  />
                </Col>
                <Col span={12}>
                  <UnifiedInput
                    form={form}
                    colSpan={24}
                    disabled={disabled ? disabled : false}
                    typ={"textArea"}
                    name={"textArea"}
                    placeHolder={"Remarks"}
                    label="TextArea"
                    errorMessage={"Please Select TextArea !"}
                    required={true}
                    defaultValue={remark ? remark : null}
                    minHeight="147px"
                  />
                  <Col span={24}>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "flex-end",
                        marginRight: "10px",
                      }}
                    >
                      <Button
                        disabled={!disabled}
                        type="primary"
                        style={{
                          fontWeight: 600,
                          borderRadius: "10px",

                          // marginBottom: 0,
                        }}
                        onClick={EditClick}
                        loading={modalVisible}
                      >
                        EDIT
                      </Button>
                    </div>
                  </Col>
                </Col>
              </Row>
            </Form>
          </div>
        </div>
      </div>
    </>
  );
}

export default RetroCards;
